import { useEffect, useState } from 'react';
import { ActivityData, VacationData, StatusData } from '../types';
import { professions } from '../data/professions';
import { DEFAULT_VACATION_SETTINGS, DEFAULT_STATUS_SETTINGS } from '../constants';

interface UrlParams {
  profession?: string;
  revenue?: string;
  shared?: string;
  embed?: string;
}

export function useUrlParams() {
  const [urlParams, setUrlParams] = useState<UrlParams>({});
  const [isEmbedMode, setIsEmbedMode] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const newParams: UrlParams = {};
    
    if (params.get('profession')) newParams.profession = params.get('profession')!;
    if (params.get('revenue')) newParams.revenue = params.get('revenue')!;
    if (params.get('shared')) newParams.shared = params.get('shared')!;
    if (params.get('embed')) newParams.embed = params.get('embed')!;
    
    setUrlParams(newParams);
    setIsEmbedMode(params.get('embed') === 'true');
  }, []);

  const getInitialStateFromUrl = () => {
    const profession = urlParams.profession 
      ? professions.find(p => p.id === urlParams.profession)
      : null;

    const activity: ActivityData = {
      profession,
      actsPerWeekMin: profession ? Math.round(profession.averageActsPerWeek * 0.8) : 0,
      actsPerWeekMax: profession ? Math.round(profession.averageActsPerWeek * 1.2) : 0,
      averageConsultationPrice: profession?.averageConsultationPrice || 0
    };

    const vacation: VacationData = DEFAULT_VACATION_SETTINGS;
    const status: StatusData = DEFAULT_STATUS_SETTINGS;

    return { activity, vacation, status };
  };

  return {
    urlParams,
    isEmbedMode,
    getInitialStateFromUrl
  };
}